import { TCustomerJourney } from '../../../Types';
import { TrackAmplitudeEventOptions } from '../Amplitude.types';

/**
 * @deprecated
 */
export const EVENT_NAMES = {
  LATEST_SIGNUP_STEP: 'loaded',
  COMPLETE_SIGNUP_STEP: 'completed',
  ACCEPT_OFFER: 'Offer selected',
  INSTANT_DECISION_CTA_CLICKED: 'Instant decision CTA clicked',
  DOCUMENTS_UPLOADED: 'Documents Uploaded',
  PAGE_VISITED: 'Signup Visited',
};

interface Category {
  SIGNUP: TCustomerJourney;
  SIGNUP_DE: TCustomerJourney;
}

const CATEGORY: Category = {
  SIGNUP: 'Signup',
  SIGNUP_DE: 'Signup DE',
};

/**
 * @deprecated
 */
export const SIGNUP_STEPS_HUMANISED = [
  'Step Zero',
  'Business details',
  'Personal details',
  'Trading details',
  'My Account',
];

/**
 * @deprecated
 */
export function getLatestSignupStepEventProperties(
  signupStep: string,
  locale: string,
) {
  const event = `${signupStep} ${EVENT_NAMES.LATEST_SIGNUP_STEP}`;

  return {
    event,
    category:
      locale?.toLowerCase() === 'de' ? CATEGORY.SIGNUP_DE : CATEGORY.SIGNUP,
  };
}

/**
 * @deprecated
 */
export function getCompletedSignupStepEventProperties(
  signupStep: string,
  locale: string,
) {
  const event = `${signupStep} ${EVENT_NAMES.COMPLETE_SIGNUP_STEP}`;

  return {
    event,
    category:
      locale?.toLowerCase() === 'de' ? CATEGORY.SIGNUP_DE : CATEGORY.SIGNUP,
  };
}

/**
 * @deprecated
 */
export function getInstantDecisionEventProperties(
  suggestedProduct: string,
  requestedProductType: string,
  locale: string,
) {
  return {
    category:
      locale?.toLowerCase() === 'de' ? CATEGORY.SIGNUP_DE : CATEGORY.SIGNUP,
    event: EVENT_NAMES.INSTANT_DECISION_CTA_CLICKED,
    payload: {
      suggestProductType: suggestedProduct,
      requestedProductType,
    },
  };
}

/**
 * @deprecated
 */
export function getDocumentsUploadedEventProperties(
  suggestedProduct: string,
  locale: string,
) {
  return {
    category:
      locale?.toLowerCase() === 'de' ? CATEGORY.SIGNUP_DE : CATEGORY.SIGNUP,
    event: EVENT_NAMES.DOCUMENTS_UPLOADED,
    payload: {
      suggestProductType: suggestedProduct,
    },
  };
}

/**
 * @deprecated
 */
export function signupEventCreator({
  event,
  payload,
  locale,
}: {
  event: string;
  locale?: string;
  payload?: object;
}): TrackAmplitudeEventOptions {
  return {
    event: event,
    category:
      locale?.toLowerCase() === 'de' ? CATEGORY.SIGNUP_DE : CATEGORY.SIGNUP,
    payload: {
      ...(payload || {}),
    },
  };
}

/**
 * @deprecated
 */
export function getPageVisitedEvent() {
  return {
    category: CATEGORY.SIGNUP,
    event: EVENT_NAMES.PAGE_VISITED,
  };
}

/**
 * @deprecated
 */
export const ACCEPT_OFFER_LIGHTING_LOAN = {
  category: CATEGORY.SIGNUP,
  event: EVENT_NAMES.ACCEPT_OFFER,
  payload: {
    offerType: 'Lighting Loan',
  },
};

/**
 * @deprecated
 */
export const ACCEPT_OFFER_RLS = {
  category: CATEGORY.SIGNUP,
  event: EVENT_NAMES.ACCEPT_OFFER,
  payload: {
    offerType: 'Recovery Loan',
  },
};

/**
 * @deprecated
 */
export const ACCEPT_OFFER_INDICATIVE = {
  category: CATEGORY.SIGNUP,
  event: EVENT_NAMES.ACCEPT_OFFER,
  payload: {
    offerType: 'Indicative Offer',
  },
};
